import React, {useEffect, useState, useRef} from "react";
import {createSearchParams, generatePath, useNavigate, useParams, useSearchParams} from "react-router-dom";
import {Card, Col, Row, Spin, Image, Grid, Collapse} from "antd";
import {useDispatch, useSelector} from "react-redux";
import {fetchCardsListAction, fetchCardsThemeListAction, ROUTE_PATH, selectStore} from "../../utils";
import {MySegmented,MyText} from "../../components";
import {LeftOutlined} from "@ant-design/icons";
import Image1 from '../../assets/images/pages/Main/psycho_support-1.webp'
import Image2 from '../../assets/images/pages/Main/psycho_support-2.webp'
import Image3 from '../../assets/images/pages/Main/psycho_support-3.webp'
import Image4 from '../../assets/images/pages/Main/psycho_support-4.webp'
import Image5 from '../../assets/images/pages/Main/psycho_support-5.webp'
import Image6 from '../../assets/images/pages/Main/psycho_support-6.webp'
import Image7 from '../../assets/images/pages/Main/psycho_support-7.webp'
import Image8 from '../../assets/images/pages/Main/psycho_support-8.webp'
import Image9 from '../../assets/images/pages/Main/psycho_support-9.webp'
import Image10 from '../../assets/images/pages/Main/psycho_support-10.webp'
import { PageName, ButtonContainer, ThemeCollapse, StyledImage, StyledImageWrapper, ScrollableCol } from "./style";
import { useTranslation } from "react-i18next";
import { useEmbeddedNavigate } from "../../utils/context/embed";
import { Helmet } from "react-helmet";

export const PsychoSupportPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const embeddedNavigate = useEmbeddedNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [searchParams, setSearchParams] = useSearchParams();
  const {t} = useTranslation("common")
  const {useBreakpoint} = Grid;
  const screens = useBreakpoint();
  const age = searchParams.get("age");
  // const {gameCategory} = useParams();
  let fromAge = "";
  let toAge = "";

  if (age) {
    [fromAge, toAge] = age.split('-');
  }
  const isMobile = screens.xs;
  const { Panel } = Collapse;
  const topicIdFromParams = searchParams.get('topic_id');
  const segmentedParams: any = searchParams.get('type');
  const [authors, setAuthors] = useState([]);
  const [articles, setArticles] = useState([]);
  const initialTopicId = topicIdFromParams ? Number(topicIdFromParams) : null;
  const [selectedSubThemeId, setSelectedSubThemeId] = useState<number | null>(initialTopicId);
  const cardsThemeList = useSelector((state: any) => state.materials?.cardsThemeList ?? { data: null, loading: false });

  const [activeKeyTheme, setActiveKeyTheme] = useState(null);
  const [selectedParentTheme, setSelectedParentTheme] = useState<any>(null);
  const [selectedSubThemeName, setSelectedSubThemeName] = useState(null);
  const [themes, setThemes] = useState([]);
  const [isThemesModalVisible, setIsThemesModalVisible] = useState(false);
  const [totalCount, setTotalCount] = useState(0);

  const isTablet = screens.md && !screens.xl && !screens.xxl;
  const scrollableRef = useRef<HTMLDivElement | null>(null);

    const SPECIALIST_TYPE = [
    {
      key: 'developing',
      title: `${t("developing")}`
    },
    {
      key: 'letsPlay',
      title: `${t("letsPlay")}`
    },
    {
      key: 'checkYourself',
      title: `${t("checkYourself")}`
    },
    {
      key: 'parentsRecommendations',
      title: `${t("parentsRecommendations")}`
    },
    {
      key: 'familyPsychology',
      title: `${t("familyPsychology")}`
    },
  ];

 const PLAY_ITEMS = [
  { id: 'sensory', text: t("sensory"), image: Image1 },
  { id: 'neurogym', text: t("neurogym"), image: Image2 },
  { id: 'art', text: t("art"), image: Image3 },
  { id: 'fairytale', text: t("fairytale"), image: Image4 },
  { id: 'speech', text: t("speech"), image: Image5 },
];

const RECOMMEND_ITEMS = [
  { id: 'mental', text: t("mental"), image: Image6 },
  { id: 'school', text: t("school"), image: Image7 },
  { id: 'adaptation', text: t("adaptation"), image: Image8 },
  { id: 'features', text: t("features"), image: Image9 },
  { id: 'support', text: t("support"), image: Image10 },
];

  const handlePanelChange = (key) => {
        setActiveKeyTheme(activeKeyTheme === key ? null : key);
    };  

  // const parentThemesButton = themes.filter(theme => theme.type === 1 && theme.parent_id == parentTheme);

  // useEffect(() => {
  //     const fetchContent = async () => {
  //         try {
  //             const response = await fetchCardsThemeList();
  //             setThemes(response.categories || []);
  //         } catch (error) {
  //             console.error('Error fetching themes:', error);
  //         }
  //     };
  
  //     fetchContent();
  // }, []);

  useEffect(() => {
    dispatch(fetchCardsThemeListAction());
  }, []);

  useEffect(() => {
    if (!cardsThemeList.success || !cardsThemeList.data) return;
    setThemes(cardsThemeList.data.categories || []);
  }, [cardsThemeList.success, cardsThemeList.data]);

  const {materials: {cardsList: cardsListState}} = useSelector(selectStore)

  useEffect(() => {
    
      dispatch(fetchCardsListAction({
        // category: gameCategory,
        // fromAge,
        // toAge
      }))
    
  }, [])

  useEffect(() => {
  const topicIdFromParams = searchParams.get('topic_id');

  if (!topicIdFromParams) {
    setSelectedSubThemeId(null);
    setSelectedSubThemeName(t("all"));
    setSelectedParentTheme({ id: null, name: t("all") });
    return;
  }

  const topicId = Number(topicIdFromParams);
  const matchedTheme = themes.find(theme => theme.id === topicId);

  if (matchedTheme) {
    setSelectedSubThemeId(topicId);
    setSelectedSubThemeName(matchedTheme.name);
    setSelectedParentTheme(matchedTheme);
  } else {
    setSelectedSubThemeId(null);
    setSelectedSubThemeName(t("all"));
    setSelectedParentTheme({ id: null, name: t("all") });
  }
}, [themes, searchParams, t]);

useEffect(() => {
    if (!segmentedParams) {
      handleChangeSegmented(SPECIALIST_TYPE[1].key);
    }
  }, [searchParams]);


 

    const handleChangeSegmented = (value: any) => {
    const existingParams = Object.fromEntries(searchParams.entries());

    const newParams: Record<string, string> = {
        ...existingParams,
        type: value,
    };

    if (selectedSubThemeId !== null) {
        newParams.topic_id = selectedSubThemeId;
    } else {
        delete newParams.topic_id;
    }

    setSearchParams(newParams);
    setSearchTerm('');

    if (value === 'familyPsychology') {
        handleSelectCard('familyPsychology');
    }
    if (value === 'developing') {
        handleSelectCard('developing');
    }
    };

  const handleSelectCard = (supportId: any) => {
    const path = {
      pathname: generatePath(ROUTE_PATH.CURRENT_PSYCHO, {  type: segmentedParams, supportId }),
    };
    embeddedNavigate(path);
  };

  const handleGoBack = () => {
    embeddedNavigate('/');
  }

  const parentThemesButton = themes;

  return (
    <>
          <Helmet>
            <title>Познавательные детские карточки</title>
            <meta name="description" content="Познавательные видео для обучения детей: речь, внимание, окружающий мир. Весёлые и полезные материалы для изучения дома и в детском саду." />
          </Helmet>


      {/* <Row style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}> */}
    <Row justify="center">
      <Col span={20}>
        <Row align="middle" style={{marginBottom: 30}}>
           {screens.xs ? (
              <>
                <Col span={3}>
                  <ButtonContainer onClick={handleGoBack}>
                    <LeftOutlined style={{ color: 'rgba(10, 3, 60, 0.7)' }} />
                  </ButtonContainer>
                </Col>
                <Col span={21}>
                  <MyText
                    color="rgba(19, 15, 38, 1)"
                    size={24}
                    weight={800}
                    style={{ fontFamily: 'Nunito', display: 'block', marginLeft: 12 }}
                  >
                    {t("psychoPedSupport")}
                  </MyText>
                </Col>
              </>
            ) : (
              <>
                <ButtonContainer onClick={handleGoBack}>
                  <LeftOutlined style={{ color: 'rgba(10, 3, 60, 0.7)' }} />
                </ButtonContainer>
                <MyText
                  color="rgba(19, 15, 38, 1)"
                  size={32}
                  weight={800}
                  style={{ fontFamily: 'Nunito', display: 'block', marginLeft: 12 }}
                >
                  {t("psychoPedSupport")}
                </MyText>
              </>
            )}
        </Row>
        <Row style={{marginBottom: 30}}>
                    <ScrollableCol ref={scrollableRef} span={24}>
            <MySegmented
                          type="primary"
                          options={SPECIALIST_TYPE.map(item => ({
                            label: item.title,
                            value: item.key,
                            disabled: !['developing', 'letsPlay', 'parentsRecommendations', 'familyPsychology'].includes(item.key),
                          }))}
                          onChange={handleChangeSegmented}
                          value={segmentedParams}
                        />
                        </ScrollableCol>
        </Row>
        <Row gutter={[32,32]}>

             {segmentedParams === "letsPlay" ? (
          PLAY_ITEMS.map((item, index) => (
            <Col key={index} span={screens.xs ? 24 : 8}>
                <Card style={{borderRadius: '20px', cursor: 'pointer'}}
                onClick={() => handleSelectCard(item.id)}
                >
                  <Row justify="center" style={{marginTop: 24}}>
                  <Col>

                  <Image
                    preview={false}
                    style={{height: 320, width: '100%'}}
                    src={item.image}
                  />
                  </Col>
                  </Row>
                
                    <Row justify="center" style={{marginTop: 24}}>
                        <Col>
                        <MyText weight={600} size={20} >
                        {item.text}
                        </MyText>
                        </Col>
                    </Row>
                </Card>
            </Col>
          ))
        ) : segmentedParams === "parentsRecommendations" ? (
  RECOMMEND_ITEMS.map((item, index) => (
    <Col key={index} span={screens.xs ? 24 : 8}>
                <Card style={{borderRadius: '20px', cursor: 'pointer'}}
                onClick={() => handleSelectCard(item.id)}
                >
                  <Row justify="center" style={{marginTop: 24}}>
                  <Col>

                  <Image
                    preview={false}
                    style={{height: 320, width: '100%'}}
                    src={item.image}
                  />
                  </Col>
                  </Row>
                
                    <Row justify="center" style={{marginTop: 24}}>
                        <Col>
                        <MyText weight={600} size={20} >
                        {item.text}
                        </MyText>
                        </Col>
                    </Row>
                </Card>
            </Col>
  ))
) : (
        <Col span={24}>
        
        <Card style={{borderRadius: '20px'}}>
          <Spin spinning={cardsListState?.loading}>
            <Row gutter={[24, 24]}>
            {cardsListState?.data?.cards?.length ? (
                cardsListState.data.cards.map((oneGame: any) => (
                  <Col
                    key={oneGame.id + "-game-category"}
                    xs={24}
                    sm={12}
                    md={12}
                    lg={12}
                    xl={12}
                  >
                    <Card
                      bordered
                      hoverable
                      onClick={() => handleSelectCard(oneGame.id)}
                      style={{
                        borderRadius: '24px',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                      }}
                    >
                      <Row justify="center" style={{height: screens.xs ? 'auto' : '500px'}}>
                        <StyledImageWrapper>
                        <Image
                            preview={false}
                            style={{height: '100%', width: '100%'}}
                            src={oneGame.preview_image}
                        />
                        </StyledImageWrapper>
                            </Row>
                            <Col style={{ marginTop: 26, padding: 0, height: '50px' }}>
                                <MyText weight={700} size={18}>
                                {oneGame.title}
                                </MyText>
                            </Col>
                            </Card>
                        </Col>
                        ))
                    ) : (
                        <MyText
                        color="rgba(19, 15, 38, 1)"
                        size={24}
                        weight={800}
                        style={{ fontFamily: 'Nunito', display: 'block' }}
                        >
                        {t("noFound")}
                        </MyText>
                    )}
                    </Row>
                </Spin>
                </Card>
                </Col>
        )}
                          </Row>

      </Col>

      
    </Row>
        {/* </Row> */}
  </>

  )
}